<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container class="window-height">
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>

export default {
  name: 'LayoutDefault',

  components: {
  },


}
</script>
